import React from 'react';
import Card from '../../../../core/layout/Card';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import Separator from '../../../../core/layout/Separator';
import StudentAccessFrequencyTableContainer from './student/StudentAccessFrequencyTableContainer';
import StudentEngagementTableContainer from './student/StudentEngagementTableContainer';
import StudentChurnTableContainer from './student/StudentChurnTableContainer';
import StudentStudyQualityTableContainer from './student/StudentStudyQualityTableContainer';
import PartnerLicensePackageUsageRateTableContainer from './partner/PartnerLicensePackageUsageRateTableContainer';
import PartnerStudentVariationTableContainer from './partner/PartnerStudentVariationTableContainer';
import PartnerAccessFrequencyTableContainer from './partner/PartnerAccessFrequencyTableContainer';

const CustomerSuccessDistributorTab = () => (
  <div>
    <Card title="Partners" collapsible>
      <Row>
        <Column size={6}>
          <PartnerAccessFrequencyTableContainer type="distributor" />
        </Column>
        <Column size={6}>
          <PartnerLicensePackageUsageRateTableContainer type="distributor" />
        </Column>
      </Row>
      <Separator />
      <Row>
        <Column size={6}>
          <PartnerStudentVariationTableContainer type="distributor" />
        </Column>
      </Row>
    </Card>
    <Separator />
    <Card title="Students" collapsible>
      <Row>
        <Column size={6}>
          <StudentAccessFrequencyTableContainer type="distributor" />
        </Column>
        <Column size={6}>
          <StudentEngagementTableContainer type="distributor" />
        </Column>
      </Row>
      <Separator />
      <Row>
        <Column size={6}>
          <StudentChurnTableContainer type="distributor" />
        </Column>
        <Column size={6}>
          <StudentStudyQualityTableContainer type="distributor" />
        </Column>
      </Row>
    </Card>
  </div>
);

export default CustomerSuccessDistributorTab;
